import { parseRoute } from "src/wac-routes";

import { useLocale } from "@/libraries/web-framework/src/localization/use-locale";
import { WAC_TO_CPAPI_LOCALE_MAP } from "@/utils/content-queries/constants";

export const useQueryLocale = () => {
    const locale = useLocale();
    return WAC_TO_CPAPI_LOCALE_MAP[locale] || "en-US";
};

export const parseQueryLocale = (location: Location) => {
    const { locale } = parseRoute(location);
    return WAC_TO_CPAPI_LOCALE_MAP[locale] || "en-US";
};
